import SiteHeader from '../komponenter/SiteHeader';
import InquiryForm from '../komponenter/InquiryForm';
import PropertyHeroSection from '../komponenter/property/PropertyHeroSection';
import PropertyLoadingState from '../komponenter/property/PropertyLoadingState';
import PropertyMapSection from '../komponenter/property/PropertyMapSection';
import PropertyNotFoundState from '../komponenter/property/PropertyNotFoundState';
import { usePropertyDetail } from '../hooks/usePropertyDetail';

function PropertyDetailPage() {
  const { error, isLoading, mapEmbedUrl, mapLinkUrl, property, returnTo } = usePropertyDetail();

  if (isLoading) {
    return (
      <>
        <SiteHeader detailLink={returnTo} />
        <PropertyLoadingState returnTo={returnTo} />
      </>
    );
  }

  if (!property) {
    return (
      <>
        <SiteHeader detailLink={returnTo} />
        <PropertyNotFoundState error={error} returnTo={returnTo} />
      </>
    );
  }

  return (
    <div className="min-h-screen text-[#183228]">
      <SiteHeader detailLink={returnTo} />
      <main className="mx-auto w-[min(1120px,calc(100%-40px))] py-10">
        <PropertyHeroSection property={property} />
        <PropertyMapSection mapEmbedUrl={mapEmbedUrl} mapLinkUrl={mapLinkUrl} property={property} />
        <section
          className="mt-6 rounded-[32px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] p-6 shadow-[0_22px_60px_rgba(24,50,40,0.08)] md:p-8"
          id="meld-interesse"
        >
          <p className="mb-2 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Meld interesse</p>
          <h2 className="font-serif text-2xl font-semibold text-[#163127]">Interessert i denne eiendommen?</h2>
          <p className="mt-2 max-w-[60ch] text-[1.05rem] leading-[1.7] text-[#355046]">
            Send oss en henvendelse, sa tar vi kontakt. Telefon og e-post legges til snart.
          </p>
          <div className="mt-6 max-w-[640px]">
            <InquiryForm propertyName={property.name} propertySlug={property.slug} />
          </div>
        </section>
      </main>
    </div>
  );
}

export default PropertyDetailPage;